import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { Typography } from '@kep-ui-kit/ui-components';
import { buttonIds } from '@selfserve/react-utils';
import { StyledV2Input, StyledV2SubmitBtn } from '@selfserve/react-ui';
import { FormValues } from '../feature/forgot-password-v2';

const StyledFormArea = styled.div(({ theme }: { theme?: any }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '100%',
}));

const StyledFieldGroup = styled.div(({ theme }: { theme?: any }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
}));

export interface Props {
  formik: FormikProps<FormValues>;
  isLoading: boolean;
}

export const ForgotPasswordFormV2 = ({
  formik: { handleSubmit, handleChange, handleBlur, values, errors, touched },
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  return (
    <form onSubmit={handleSubmit}>
      <StyledFormArea>
        <StyledFieldGroup>
          <Typography variant={'body1Highlight' as any}>
            {t('common.email')}
          </Typography>
          <StyledV2Input
            id="fpv2-email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            hasError={touched.email && !!errors.email}
            autoFocus
            autoComplete="email"
            aria-label={t('aria.email')}
          />
          {touched.email && errors.email && (
            <Typography
              variant={'formError' as any}
              sx={{ mt: 0.5, color: (theme: any) => theme.palette.danger.main, fontWeight: 700 }}
            >
              {errors.email}
            </Typography>
          )}
        </StyledFieldGroup>
        <StyledV2SubmitBtn
          id={buttonIds.resetPasswordSendInstructions}
          type="submit"
          disabled={isLoading}
          fullWidth
        >
          {t('common.send-instructions')}
        </StyledV2SubmitBtn>
      </StyledFormArea>
    </form>
  );
};
